export default (that) => [
  {
    text: that.$l('menu_label_edit') || '编辑客户信息',
    icon: 'el-icon-edit',
    menuType: 'editV2',
    allow: 'M',
    // disabled: ({ custMode }) => !['A'].includes(custMode),
  },
  {
    text: that.$l('menu_label_riskAssessment') || '财务风险核查',
    icon: 'el-icon-s-claim',
    menuType: 'risk-assessment',
    allow: 'R',
    divided: true,
  },
  {
    text: that.$l('menu_label_convertPotential') || '转成潜在客户',
    icon: 'el-icon-user',
    menuType: 'convertPotential',
    allow: 'CP',
    divided: true,
    disabled: ({ custMode }) => !['A'].includes(custMode),
  },
  {
    text: that.$l('menu_label_convertFormal') || '转成正式客户',
    icon: 'el-icon-check',
    menuType: 'convertFormal',
    allow: 'CF',
    disabled: ({ custMode }) => !['A', 'B'].includes(custMode),
  },
  {
    text: that.$l('menu_label_info_changes') || '基本信息变更',
    icon: 'el-icon-edit-outline',
    menuType: 'infoChange',
    allow: 'EP',
    disabled: ({ custMode }) => !['B', 'C'].includes(custMode),
    divided: true,
  },
  {
    text: that.$l('menu_label_order_changes') || '接单信息变更',
    icon: 'el-icon-coin',
    menuType: 'orderChange',
    allow: 'EO',
    disabled: ({ custMode }) => !['B', 'C'].includes(custMode),
  },
  {
    text: that.$l('menu_label_bank_change') || '银行账号变更',
    icon: 'el-icon-discount',
    menuType: 'bankChange',
    allow: 'EB',
    disabled: ({ custMode }) => !['B', 'C'].includes(custMode),
  },
]
